import axios from "axios";
import wpCall from "../services/WpServerCall";
import { generalQueriesDocumentsMockup } from "../views/GeneralQueries/GeneralQueriesConstants";

export const getMapsDataFromWordpress = () => {
    return wpCall().get('/web/v1/generalQueriesMaps').then(({data}) => data);
}

export const getDocumentsFromWordpress = () => {
    return wpCall().get('/web/v1/documentsInfo').then(({data}) => data);
}

export const getDocumentsFromTransparencia = async () => {
    const envUrl = process.env.REACT_APP_TRANSPARENCIA_API_URL;
    const targetUrl = (envUrl && envUrl.startsWith('http')) 
        ? envUrl 
        : 'https://mitur.gob.do/api/endpoints/transparencia.php';
    
    try {
        const response = await axios.get(targetUrl, {
            params: {
                category: 'base_legal'
            },
            headers: {
                'Accept': 'application/json'
            },
            timeout: 10000
        });
        if (response.data && (Array.isArray(response.data) ? response.data.length > 0 : Object.keys(response.data).length > 0)) {
            return response.data;
        }
    } catch (axiosError) {
        console.warn("Transparencia primary API error/CORS, checking fallback sources...", axiosError);
    }

    try {
        const wpData = await wpCall().get('/web/v1/documentsInfo').then(({ data }) => data);
        if (wpData && (Array.isArray(wpData) ? wpData.length > 0 : Object.keys(wpData).length > 0)) {
            return wpData;
        }
    } catch (wpError) {
        console.warn("WordPress documentsInfo endpoint failed, loading default legal dataset...", wpError);
    }

    return generalQueriesDocumentsMockup;
};